<nav #navbarRoot class="bg-[#FCFCFD]">
  <div class="w-full flex justify-center">
    <div class="w-full max-w-[1280px] px-3 md:px-6 py-4 md:py-6 flex items-center justify-between">

      <!-- Logo -->
      <a routerLink="/" class="flex h-[36px] items-center gap-[3px] cursor-pointer" aria-label="Encargomio">
        <div class="flex w-[24px] h-[24px] flex-shrink-0">
          <img src="home/navbar/Logo Icon.svg" alt="Icono Encargomio" class="w-full h-full" />
        </div>
        <div class="flex w-[80px] h-[14px] flex-shrink-0 pt-[1.368px]">
          <img src="home/navbar/Logo Text.svg" alt="Encargomio" class="w-[79.916px] h-[13.01px]" />
        </div>
      </a>

      <div class="flex items-center gap-[10px]">
        <!-- Botón derecho  -->
        @if (isLoginPage) {
          <!-- En Login -> mostrar Registrarse -->
          <a
            routerLink="/auth/register"
            class="flex items-center justify-center h-[40px] md:h-[50px]
                   px-4 md:px-[42px] rounded-[4px]
                   bg-[linear-gradient(201.262deg,var(--Brand-Gradient-Start)_18.26%,var(--Brand-Gradient-End)_96.72%)]
                   text-neutral-color-neutral-2 font-inter text-[12px] font-medium leading-[18px] tracking-[0.04px]
                   hover:opacity-90 transition-opacity cursor-pointer border-0">
            {{ 'NAVBAR.REGISTER' | translate }}
          </a>
        } @else {
          <!-- En Register -> mostrar {{ 'NAVBAR.LOGIN' | translate }} -->
          <a
            routerLink="/auth/login"
            class="flex items-center justify-center h-[40px] md:h-[50px]
                   px-4 md:px-[24px] rounded-[4px]
                   bg-transparent text-[#1C2024]
                   font-inter text-[12px] font-semibold leading-[16px] tracking-[0.04px]
                   hover:text-[#6564BE] transition-colors border-0 cursor-pointer">
            {{ 'NAVBAR.LOGIN' | translate }}
          </a>
        }
      </div>

    </div>
  </div>

  @if (menuOpen$ | async) {
    <app-menu [topOffsetPx]="navbarHeightPx" (closed)="menuFacade.closeMenu()" (action)="onMenuAction($event)" />
  }
</nav>
